(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * ログ送信
 * @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
 * @param messageID メッセージID
 */
'use strict';

var sendLog = function sendLog(target, messageID) {
  if (!s) return;
  s.tl(target, 'o', messageID);
};

// 【'DOMContentLoaded'の削除禁止】
// 通常include系資材は</body>直前で読み込ませますが、
// 原稿制作システム（しろくま）のzipファイルアップロード時、vos.jsの配置制約（</body>直前）に伴うシステムエラーを避けるため、
// DOMContentLoadedにより実行順を制御しています。
document.addEventListener('DOMContentLoaded', function () {
  // URLにSCコードの条件にマッチした文字列が含まれるか判定する
  var scCodeMatch = window.location.href.match(/SC\d{6}/);

  // 全てのリンク要素を取得する
  var links = document.querySelectorAll('a');

  // URLからSCコードが取得できなかった場合、又はリンク要素が一つも存在してない場合、処理を終了する
  if (!scCodeMatch || links.length === 0) return;

  var scCode = scCodeMatch[0];

  links.forEach(function (link) {
    // リンク要素のhref値を取得する
    var hrefValue = link.getAttribute('href');

    // href値が存在しない場合、即時リターンする
    if (!hrefValue) return;

    // target属性に_blankが設定されている場合
    if (link.target === '_blank') {
      // 外部遷移のクリックログdata属性を付与する
      link.setAttribute('data-click-log', 'Gsp_ex_' + (scCode + '_' + hrefValue));
      link.addEventListener('click', function (event) {
        var clickedElement = event.currentTarget;
        var customLink = clickedElement.dataset['clickLog'];
        sendLog(clickedElement, customLink);
        event.stopPropagation();
      });
    }
  });
});

},{}]},{},[1]);
